'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.diffusionServiceUtils = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _PricesStateStore = require('../stores/PricesStateStore');

var _DIFFUSION = require('../constants/DIFFUSION');

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _DiffusionFeedHelper = require('./DiffusionFeedHelper');

var _DiffusionFeedHelper2 = _interopRequireDefault(_DiffusionFeedHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTopicRaceType() {
    return 'HORSES';
}

function getTopicInfoType() {
    return '#INFO';
}

function getTopicMarketType(type) {
    return type || 'WIN';
}

function getElementDataAttribute(attribute, element) {
    return (0, _jquery2.default)(element).closest('[' + attribute + ']').attr(attribute);
}

function getTopicRaceDate(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, element);
}

function getTopicCourseName(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, element);
}

function getTopicRaceTime(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, element);
}

function getTopicHorseName(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, element);
}

function getTopicBookmaker(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER, element);
}

function getElementDiffusionData(element) {
    return {
        horseName: getTopicHorseName(element),
        courseName: getTopicCourseName(element),
        raceTime: getTopicRaceTime(element),
        raceDate: getTopicRaceDate(element)
    };
}

function createInfoTopic(_ref) {
    var raceDate = _ref.raceDate,
        courseName = _ref.courseName,
        raceTime = _ref.raceTime,
        bookmaker = _ref.bookmaker;

    if (!raceDate || !courseName || !raceTime || !bookmaker) {
        // eslint-disable-next-line no-console
        console.error('info topic not created', raceDate, courseName, raceTime, bookmaker);
        return null;
    }

    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), getTopicInfoType(), _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];

    return topicArray.join('/');
}

function createPriceTopic(_ref2) {
    var raceDate = _ref2.raceDate,
        courseName = _ref2.courseName,
        raceTime = _ref2.raceTime,
        horseName = _ref2.horseName,
        bookmaker = _ref2.bookmaker;

    if (!raceDate || !courseName || !raceTime || !horseName || !bookmaker) {
        // eslint-disable-next-line no-console
        console.error('price topic not created', raceDate, courseName, raceTime, horseName, bookmaker);
        return null;
    }

    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), horseName, _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];

    return topicArray.join('/');
}

function parseDiffusionTopic(topic) {
    var topicArray = topic.split('/');
    return {
        raceType: topicArray[0],
        raceDate: topicArray[1],
        courseName: topicArray[2],
        raceTime: topicArray[3],
        marketType: topicArray[4],
        infoType: topicArray[5],
        bookmaker: topicArray[6]
    };
}

function parseInfoTopicData(WebClientMessage) {
    var _WebClientMessage$get = WebClientMessage.getFields(0),
        _WebClientMessage$get2 = _slicedToArray(_WebClientMessage$get, 4),
        eachwayTerms = _WebClientMessage$get2[0],
        isBog = _WebClientMessage$get2[1],
        suspendState = _WebClientMessage$get2[2],
        orderBy = _WebClientMessage$get2[3];

    var isWinOnly = eachwayTerms === '1/1|1-1';

    var _eachwayTerms$split = eachwayTerms.split('|'),
        _eachwayTerms$split2 = _slicedToArray(_eachwayTerms$split, 2),
        winOdds = _eachwayTerms$split2[0],
        placeWinner = _eachwayTerms$split2[1];

    var topic = WebClientMessage.getTopic();

    var _parseDiffusionTopic = parseDiffusionTopic(topic),
        bookmaker = _parseDiffusionTopic.bookmaker,
        courseName = _parseDiffusionTopic.courseName,
        raceDate = _parseDiffusionTopic.raceDate,
        raceTime = _parseDiffusionTopic.raceTime;

    return {
        raceDate: raceDate,
        courseName: courseName,
        raceTime: raceTime,
        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
        winOdds: winOdds,
        placeWinner: placeWinner,
        isWinOnly: isWinOnly,
        isBog: isBog,
        suspendState: suspendState,
        orderBy: orderBy
    };
}

function parsePriceTopicData(WebClientMessage) {
    var dataFields = WebClientMessage.getFields(0);
    var topic = WebClientMessage.getTopic();

    var _parseDiffusionTopic2 = parseDiffusionTopic(topic),
        horseName = _parseDiffusionTopic2.infoType,
        bookmaker = _parseDiffusionTopic2.bookmaker,
        courseName = _parseDiffusionTopic2.courseName,
        raceDate = _parseDiffusionTopic2.raceDate,
        raceTime = _parseDiffusionTopic2.raceTime;

    var historyPrices = {
        fractional: dataFields.slice(9, 14),
        decimal: dataFields.slice(14, 19)
    };

    return {
        horseName: horseName,
        raceDate: raceDate,
        courseName: courseName,
        raceTime: raceTime,
        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
        historyPrices: historyPrices,
        outcomersId: dataFields[1],
        eventId: dataFields[4],
        meetingId: dataFields[5],
        status: dataFields[6],
        fractionalPrice: dataFields[7],
        decimalPrice: dataFields[8],
        historyPrice: dataFields[14]
    };
}

function getDisplayedPriceValue(renderConfig) {
    var result = void 0;
    var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
    var raceSuspendState = raceInfo && raceInfo.suspendState;
    var isHorseSuspended = [renderConfig.status, raceSuspendState].includes('H');

    if (isHorseSuspended) {
        return '-';
    }
    if (!renderConfig.decimalPrice && !renderConfig.fractionalPrice) {
        return '';
    }
    if (!renderConfig.decimalPrice) {
        return 'SP';
    }
    if (_PricesStateStore.pricesStateStore.isDecimalPrice()) {
        result = Math.floor(parseFloat(renderConfig.decimalPrice) * 100) / 100;
    } else {
        result = renderConfig.fractionalPrice;
    }
    if (renderConfig.bookmaker === 'TOTE') {
        result = parseFloat(result).toFixed(2);
    }
    return result;
}

function getPriceContainer(horseData) {
    return (0, _jquery2.default)('[' + _DIFFUSION2.default.DATA.INPUT.HORSE_NAME + ']').toArray().filter(function (element) {
        var _getElementDiffusionD = getElementDiffusionData(element),
            courseName = _getElementDiffusionD.courseName,
            raceTime = _getElementDiffusionD.raceTime,
            raceDate = _getElementDiffusionD.raceDate,
            horseName = _getElementDiffusionD.horseName;

        return horseName.toUpperCase() === horseData.horseName.toUpperCase() && raceDate === horseData.raceDate && raceTime === horseData.raceTime && courseName === horseData.courseName;
    });
}
// TODO: export by default or export all methods separately (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */
var diffusionServiceUtils = exports.diffusionServiceUtils = {
    getTopicRaceType: getTopicRaceType,
    getTopicInfoType: getTopicInfoType,
    getTopicMarketType: getTopicMarketType,
    getTopicRaceDate: getTopicRaceDate,
    getTopicCourseName: getTopicCourseName,
    getTopicRaceTime: getTopicRaceTime,
    getTopicHorseName: getTopicHorseName,
    getTopicBookmaker: getTopicBookmaker,
    getElementDataAttribute: getElementDataAttribute,
    getElementDiffusionData: getElementDiffusionData,
    createInfoTopic: createInfoTopic,
    createPriceTopic: createPriceTopic,
    parseDiffusionTopic: parseDiffusionTopic,
    parseInfoTopicData: parseInfoTopicData,
    parsePriceTopicData: parsePriceTopicData,
    getDisplayedPriceValue: getDisplayedPriceValue,
    getPriceContainer: getPriceContainer
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/DiffusionServiceUtils.js
// module id = 141
// module chunks = 1